import Vue from "vue";
import Router from "vue-router";

import Login from "@/views/Login.vue";
import PaginaHome from "@/views/PaginaHome.vue";
import Dashboard from "@/views/Dashboard.vue";
import Signup from "@/views/Signup.vue";
import Callback from "@/views/Callback.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/signup",
      name: "Singup",
      component: Signup,
      meta: { guestOnly: true, favicon: "/favicon_electroliga.ico" },
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { guestOnly: true, favicon: "/favicon_electroliga.ico" },
    },

    {
      path: '/auth-callback',
      name: "AuthCallback",
      component: Callback,
      meta: { guestOnly: true, favicon: "/favicon_electroliga.ico" },
    },
  
    {
      path: "/",
      component: PaginaHome,
      meta: { requiresAuth: true, favicon: "/favicon_electroliga.ico" },
      children: [
        {
          path: "",
          name: "Dashboard",
          component: Dashboard,
          meta: { requiresAuth: true },
        },
      ],
    },
    { path: "*", redirect: "/" },
  ],
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("authToken");
  const isAuthed = !!token;

  const matchedWithFavicon = [...to.matched].reverse().find(r => r.meta && r.meta.favicon);
  const faviconUrl = matchedWithFavicon?.meta?.favicon || "/favicon_electroliga.ico";

  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = faviconUrl;

  if (to.matched.some((r) => r.meta.requiresAuth) && !isAuthed) {

    return next({ path: "/login", query: { redirect: to.fullPath } });
  }

  if (to.matched.some((r) => r.meta.guestOnly) && isAuthed) {
    return next("/");
  }

  next();
});

export default router;
